export const TYPES = ['all', 'movie', 'series', 'documentary', 'interview', 'course', 'mentorship', 'news', 'class', 'other'];

export const TYPE_LABELS = {
  all: 'All',
  movie: 'Movies',
  series: 'Series',
  documentary: 'Documentaries',
  interview: 'Interviews',
  course: 'Courses',
  mentorship: 'Mentorships',
  news: 'News',
  class: 'Classes',
  other: 'Other'
};

export const SUBGENRES = {
  movie: ['all', 'comedia', 'terror', 'scifi', 'clasicas', 'drama', 'otros'],
  series: ['all', 'comedia', 'drama', 'thriller', 'scifi', 'docuserie', 'otros'],
  documentary: ['all', 'naturaleza', 'historia', 'sociedad', 'ciencia', 'biografico', 'otros'],
  interview: ['all', 'musica', 'cine', 'tecnologia', 'deportes', 'politica', 'otros'],
  course: ['all', 'programacion', 'diseno', 'marketing', 'finanzas', 'idiomas', 'otros'],
  mentorship: ['all', 'negocios', 'tecnologia', 'creatividad', 'liderazgo', 'otros'],
  news: ['all', 'tecnologia', 'economia', 'cultura', 'deportes', 'politica', 'otros'],
  class: ['all', 'matematicas', 'ciencias', 'historia', 'arte', 'musica', 'otros'],
  other: ['all', 'podcast', 'livestream', 'cortometraje', 'otros']
};

export const SUBGENRE_LABELS = {
  all: 'All', comedia: 'Comedy', terror: 'Horror', scifi: 'Sci-Fi', clasicas: 'Classics',
  drama: 'Drama', thriller: 'Thriller', docuserie: 'Docuseries', naturaleza: 'Nature',
  historia: 'History', sociedad: 'Society', ciencia: 'Science', biografico: 'Biography',
  musica: 'Music', cine: 'Cinema', tecnologia: 'Technology', deportes: 'Sports',
  politica: 'Politics', programacion: 'Programming', diseno: 'Design', marketing: 'Marketing',
  finanzas: 'Finance', idiomas: 'Languages', negocios: 'Business', creatividad: 'Creativity',
  liderazgo: 'Leadership', economia: 'Economics', cultura: 'Culture', matematicas: 'Mathematics',
  ciencias: 'Sciences', arte: 'Art', podcast: 'Podcast', livestream: 'Livestream',
  cortometraje: 'Short Film', otros: 'Other'
};
